import { httpV2 } from "../http.js";

const isEmail = (q) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(q.trim());
const isPhone = (q) => /^[\d\s()+-]{6,}$/.test(q.trim().replace(/\s+/g, ""));

const NewMessageService = {
  searchGuests: (q) =>
    httpV2.post("/reservations/search", {
      search_term: q,
      search_email: isEmail(q) ? q.trim() : "",
      search_phone: isPhone(q) ? q.trim() : "",
      filters: "all",
      preset: "all",
      start_date: "2000-01-01",
      end_date: "2050-12-31",
      end_type: "check_in",
      page: 0,
      checked_in: false,
      checked_out: false,
      categories: "",
      type: "message",
    }),
  searchContacts: (q) =>
    httpV2.get(
      `/contacts/search?${new URLSearchParams({
        search_term: q,
        search_email: isEmail(q) ? q.trim() : "",
        search_phone: isPhone(q) ? q.trim() : "",
        sort: "updated_at",
        tag: "",
        type: "",
        property: "",
        per: "20",
        page: 0,
      }).toString()}`,
    ),
  quickSearch: (q) =>
    httpV2.get(
      `/contacts/quick-search?${new URLSearchParams({
        search: q,
      }).toString()}`,
    ),
  createContact: (contact) => httpV2.post("/contacts", contact),
  sendGuestMessage: (payload) => httpV2.post("messaging/outbound", payload),
  sendContactMessage: (payload) => httpV2.post("/contacts/message", payload),
  sendEmailMessage: (payload) => httpV2.post("/email/create", payload),
  getTeamMembers: () => httpV2.get("/messaging/team-members"),
  searchTeamConversations: (search) =>
    httpV2.get(
      `/messaging/team-conversations?${new URLSearchParams({
        search,
      }).toString()}`,
    ),
  findTeamConversation: (participantIds) =>
    httpV2.get(
      `/messaging/team-conversations/exact?${new URLSearchParams({
        participant_ids: participantIds.join(","),
      }).toString()}`,
    ),
  updateTeamConversationLabel: (threadId, label) =>
    httpV2.put(`/messaging/team-conversations/${threadId}/label`, {
      label,
    }),
  sendTeamMessage: (payload) => httpV2.post("/messaging/internal", payload),
};

export default NewMessageService;
